// app/components/approval/ApproveAllFooter.tsx
import { t } from "i18next";
interface ApproveAllFooterProps {
  hasMore: boolean;
  approveAllCount: number;
  onLoadMore: () => void;
  onApproveAll: () => void;
}

const ApproveAllFooter = ({
  hasMore,
  approveAllCount,
  onLoadMore,
  onApproveAll,
}: ApproveAllFooterProps) => {
  return (
    <div className="gx-approve-all-footer">
       
      <button
        type="button"
        className="gx-approve-all-footer__load-more gx-p12-m"
        onClick={onLoadMore}
        disabled={!hasMore}
      >
        {t("load_more")}
      </button>
       
      {approveAllCount > 0 && (
        <button
          type="button"
          className="gx-approve-all-footer__approve-all gx-p12-b"
          onClick={onApproveAll}
        >
          {t("view_all")} ({approveAllCount})
        </button>
      )}
    </div>
  );
};

export default ApproveAllFooter;
